import { HOTJAR_ID } from "../env";

const HOTJAR_SCRIPT_ID = "portal-hotjar-tracking-code";
const HOTJAR_SNIPPET_VERSION = 6;
const HOTJAR_SITE_ID_PATTERN = /^\d+$/;

let initializedSiteId = null;
let lastTrackedPagePath = null;

function normalizePagePath(pagePath) {
  if (typeof pagePath !== "string" || !pagePath.startsWith("/")) {
    return "/";
  }

  return pagePath.replace(/\/+$/, "") || "/";
}

function getHotjarQueue() {
  if (typeof window === "undefined") {
    return null;
  }

  if (!window.hj) {
    window.hj = function hotjarQueue() {
      window.hj.q = window.hj.q || [];
      window.hj.q.push(arguments);
    };
  }

  return window.hj;
}

export function initializeHotjar(siteId = HOTJAR_ID) {
  const normalizedSiteId = String(siteId || "").trim();

  if (!normalizedSiteId) {
    return false;
  }

  if (!HOTJAR_SITE_ID_PATTERN.test(normalizedSiteId)) {
    console.error("Identificador do Hotjar inválido.");
    return false;
  }

  if (initializedSiteId === normalizedSiteId) {
    return true;
  }

  if (initializedSiteId) {
    console.error("O Hotjar já foi inicializado com outro identificador.");
    return false;
  }

  const hotjarQueue = getHotjarQueue();

  if (!hotjarQueue) {
    return false;
  }

  window._hjSettings = {
    hjid: Number(normalizedSiteId),
    hjsv: HOTJAR_SNIPPET_VERSION
  };

  if (!document.getElementById(HOTJAR_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = HOTJAR_SCRIPT_ID;
    script.async = true;
    script.src =
      `https://static.hotjar.com/c/hotjar-${normalizedSiteId}` +
      `.js?sv=${HOTJAR_SNIPPET_VERSION}`;
    document.head.appendChild(script);
  }

  initializedSiteId = normalizedSiteId;
  lastTrackedPagePath = normalizePagePath(window.location.pathname);
  return true;
}

export function trackHotjarPageView(pagePath) {
  const normalizedPagePath = normalizePagePath(pagePath);

  if (
    !initializedSiteId ||
    typeof window === "undefined" ||
    typeof window.hj !== "function" ||
    lastTrackedPagePath === normalizedPagePath
  ) {
    return false;
  }

  window.hj("stateChange", normalizedPagePath);
  lastTrackedPagePath = normalizedPagePath;
  return true;
}
